export default __webpack_public_path__ + "static/media/signin.1cd80a7e.png";